<template>
  <div>
    <vx-card>
      <List :subjectPermission="subjectPermission"></List>
    </vx-card>
  </div>
</template>

<script>
import List from "./ListCupoms";

export default {
  data() {
    return {
      subjectPermission: "Cupoms",
    };
  },
  methods: {},
  components: {
    List,
  },
};
</script>
